export default __webpack_public_path__ + "static/media/Caravanserai.b92f10f7.jpg";